import {makeStyles} from '@material-ui/core'

export const useStyles = makeStyles(() => ({
    checkboxLabel: {
      fontSize: '14px',
      lineHeight: '20px',
    },
    button: {
      textTransform: 'uppercase',
    }
  }
))
